module.exports = __webpack_public_path__ + "img/frame-browser-foujita-ja copy.1064dafd.jpg";